export const texts = {
	"cashback": {
		"en": "Cashback",
		"hi": "कैशबैक",
		"ma": "पैसे परत",
		"gj": "પાછા આવેલા પૈસા"
	},
	"history": {
		"en": "History",
		"hi": "इतिहास",
		"ma": "इतिहास",
		"gj": "ઇતિહાસ"
	},
	"game": {
		"en": "Game",
		"hi": "खेल",
		"ma": "खेळ",
		"gj": "રમત"
	},
	"leaderboard": {
		"en": "Leaderboard",
		"hi": "लीडरबोर्ड",
		"ma": "लीडरबोर्ड",
		"gj": "લીડરબોર્ડ"
	},
	"prizes": {
		"en": "Prizes",
		"hi": "पुरस्कार",
		"ma": "बक्षिसे",
		"gj": "ઇનામ"
	},
	"live": {
		"en": "LIVE",
		"hi": "लाइव",
		"ma": "राहतात",
		"gj": "જીવંત"
	},
	"ends": {
		"en": "Ends",
		"hi": "समाप्त होता है",
		"ma": "संपेल",
		"gj": "અંત થાય છે"
	},
	"starts": {
		"en": "STARTS",
		"hi": "शुरू होता है",
		"ma": "सुरू होते",
		"gj": "શરૂ થાય છે"
	},
	"in": {
		"en": "In",
		"hi": "में",
		"ma": "मध्ये",
		"gj": "માં"
	},
	"games": {
		"en": "Games",
		"hi": "खेल",
		"ma": "खेळ",
		"gj": "રમતો"
	},
	"rank": {
		"en": "Rank",
		"hi": "पद",
		"ma": "रँक",
		"gj": "ક્રમ"
	},
	"player": {
		"en": "Player",
		"hi": "खिलाड़ी",
		"ma": "खेळाडू",
		"gj": "ખેલાડી"
	},
	"played": {
		"en": "Played",
		"hi": "खेला",
		"ma": "खेळले",
		"gj": "રમ્યા"
	},
	"prize": {
		"en": "Prize",
		"hi": "इनाम",
		"ma": "बक्षीस",
		"gj": "ઇનામ"
	},
	"share your rank": {
		"en": "Share your Rank",
		"hi": "अपनी रैंक साझा करें",
		"ma": "आपली रँक सामायिक करा",
		"gj": "તમારી રેન્ક શેર કરો"
	},
	"game time": {
		"en": "Game Time",
		"hi": "खेलने का समय",
		"ma": "खेळाची वेळ",
		"gj": "રમત સમય"
	},
	"players joined": {
		"en": "Players Joined",
		"hi": "खिलाड़ी शामिल",
		"ma": "खेळाडू सामील",
		"gj": "ખેલાડીઓ જોડાયા"
	},
	"winners": {
		"en": "Winners",
		"hi": "विजेता",
		"ma": "विजेते",
		"gj": "વિજેતાઓ"
	},
	"play": {
		"en": "Play",
		"hi": "खेलिए",
		"ma": "खेळा",
		"gj": "રમ"
	},
	"game ends in": {
		"en": "Game ends in",
		"hi": "खेल समाप्त होगा",
		"ma": "खेळ संपला",
		"gj": "રમત સમાપ્ત થાય છે"
	},
	"tournament history": {
		"en": "Tournament History",
		"hi": "टूर्नामेंट का इतिहास",
		"ma": "स्पर्धा इतिहास",
		"gj": "ટુર્નામેન્ટ ઇતિહાસ"
	},
	"completed": {
		"en": "Completed",
		"hi": "पूरा कर लिया है",
		"ma": "पूर्ण",
		"gj": "પૂર્ણ"
	},
	"total prize": {
		"en": "Total Prize",
		"hi": "कुल पुरस्कार",
		"ma": "एकूण बक्षीस",
		"gj": "કુલ ઇનામ"
	},
	"entry fee": {
		"en": "Entry Fee",
		"hi": "प्रवेश शुल्क",
		"ma": "प्रवेश शुल्क",
		"gj": "પ્રવેશ ફી"
	},
	"your rank": {
		"en": "Your Rank",
		"hi": "आपका रैंक",
		"ma": "आपली रँक",
		"gj": "તમારા ક્રમ"
	},
	"free": {
		"en": "Free",
		"hi": "नि: शुल्क",
		"ma": "फुकट",
		"gj": "મફત"
	},
	"to": {
		"en": "to",
		"hi": "से",
		"ma": "पर्यंत",
		"gj": "સુધી"
	},
	"rules": {
		"en": "Rules",
		"hi": "नियम",
		"ma": "नियम",
		"gj": "નિયમો"
	},
	"please_wait_text": {
		"en": "Please wait while we redirect you to the game!",
		"hi": "कृपया प्रतीक्षा करें, जबकि हम आपको खेल में पुनर्निर्देशित करते हैं!",
		"ma": "कृपया आम्ही आपल्याला खेळाकडे पुनर्निर्देशित करेपर्यंत प्रतीक्षा करा!",
		"gj": "કૃપા કરી રાહ જુઓ જ્યારે અમે તમને રમત પર રીડાયરેક્ટ કરીએ!"
	}
}